import React, { useState } from "react";

import { RcFile } from "antd/es/upload";
import capitalize from "lodash/capitalize";
import moment from "moment";

import { updateProgramContract } from "services";

import { getProgramInternalName, handleS3Download, useGetAllCarbonPrograms, useGetProgramContractsAdmin } from "utils";

import { CarbonProgram, ProgramContract } from "models";

import { Button, Col, Flex, Icon, ModalContent, Row, Table, TablePanel, Tag, Tooltip, Upload } from "components";

const handleUpload = async (file: RcFile, programId: string) => {
  await updateProgramContract({
    file,
    programId,
  });

  return false;
};

const ContractRow = ({ contract }: { contract: ProgramContract }) => (
  <>
    <Flex align="center" justify="space-between">
      <div>
        {contract.replacedById === null && (
          <>
            <Tag colour="green" text="Active" />
            <br />
          </>
        )}
        <span className={contract.replacedById ? "grey-text" : ""}>ID: {contract.id}</span>
        <br />
        <span className={contract.replacedById ? "grey-text" : ""}>Uploaded at: {moment(contract.createdAt).format("DD.MM.YYYY")}</span>
      </div>
      <Icon className="margin-left-100 pointer" iconName="tabler/download" onClick={() => handleS3Download(contract.link)} />
    </Flex>
    <hr className="margin-bottom-100" />
  </>
);

const Content = ({ carbonProgram }: { carbonProgram: CarbonProgram }) => {
  const { data: existingContracts } = useGetProgramContractsAdmin(carbonProgram.id);

  return (
    <>
      <h3 className="margin-bottom-200">{`Program contracts: ${getProgramInternalName(carbonProgram)}`}</h3>
      <div className="margin-bottom-200">
        {existingContracts?.map((contract: ProgramContract) => <ContractRow contract={contract} key={contract.id} />) ?? null}
      </div>
      <p>
        {existingContracts?.length
          ? "Replacing the existing contract for this program will mean all farmers who are enrolled in it, will see a popup where they are shown the new contract."
          : "No contract uploaded"}
      </p>
      <Upload name="file" showUploadList={false} action="" beforeUpload={(v) => handleUpload(v, carbonProgram.id)} className="auto-height contract-upload">
        <Button block>{existingContracts?.length ? "Replace contract" : "Upload contract"}</Button>
      </Upload>
    </>
  );
};

export const Overview = () => {
  const { data: carbonPrograms = [] } = useGetAllCarbonPrograms();

  const [isProgramModalOpen, setIsProgramModalOpen] = useState<boolean>(false);
  const [selectedProgram, setSelectedProgram] = useState<CarbonProgram | null>(null);

  const handleClick = (id: string) => {
    setSelectedProgram(carbonPrograms.find((program) => program.id === id) ?? null);
    setIsProgramModalOpen(true);
  };

  const handleModalClose = () => {
    setIsProgramModalOpen(false);
    setSelectedProgram(null);
  };

  const data = carbonPrograms.map((program) => {
    const { id, partnerName, accountingMethodology, country, farmCount } = program;

    return {
      key: id,
      "program name": <TablePanel headline={getProgramInternalName(program)} />,
      "partner name": <span className="paragraph-m">{partnerName}</span>,
      methodology: <span className="paragraph-m">{capitalize(accountingMethodology)}</span>,
      country: <span className="paragraph-m">{country}</span>,
      "farm count": <span className="paragraph-m">{farmCount}</span>,
      " ": (
        <Tooltip title="Update program contract">
          <Icon className="pointer" iconName="tabler/settings" onClick={() => handleClick(id)} />
        </Tooltip>
      ),
    };
  });

  return (
    <>
      <Row>
        <Col>
          <Table data={data} className={"farms"} loading={!carbonPrograms.length} />
        </Col>
      </Row>
      {selectedProgram && (
        <ModalContent visible={isProgramModalOpen} onCancel={handleModalClose}>
          <Content carbonProgram={selectedProgram} />
        </ModalContent>
      )}
    </>
  );
};
